<app-loader *ngIf="showLoader"></app-loader>
<div class="inner-wrapper">
    <app-option-selection></app-option-selection>
    <form class="form-field" [formGroup]="loginExist" novalidate>
        <div class="loginexist-name">
            <h3 *ngIf="userNameFromStorage != ''">Hello, <span class="text-pink"><strong>{{userNameFromStorage}}</strong></span></h3>
            <div class="client-code-details">
                <span class="client-code">{{clientCodeFromStorage}}</span>
                <span class="link" (click)="changeLogin()" >Switch Account</span>
            </div>
        </div>
        <div class="label--wrapper">
            <label>Unlock Using PIN</label>
            <span class="link" (click)="forgotMPIN()">FORGOT PIN</span>
        </div>

        <div class="otp-verifications-input">
            <app-pin-input
                [length]="6"
                [inputType]="'password'"
                [hasError]="incorrectPIN"
                [autoFocus]="true"
                [(ngModel)]="pinValue"
                [ngModelOptions]="{standalone: true}"
                (enterPressed)="verifyPin()"
            ></app-pin-input>
            <div *ngIf="incorrectPIN">
                <span class="error-text">{{ pinError }}</span>
            </div>
        </div>
        <div id="example-container"  data-theme ='auto'></div>
        <button class="btn-dark btn-block" #btnVerified id="btnVerifyOTPMPIN" [disabled]="loginExist.invalid" (click)="verifyPin()">Proceed</button>
</form>
</div>
